namespace RioERP.Masters {
    export interface TawkToChatForm {
        ChatId: Serenity.StringEditor;
        StartTime: Serenity.DateEditor;
        Name: Serenity.StringEditor;
        Email: Serenity.StringEditor;
        Mobile: Serenity.StringEditor;
        SerialKey: Serenity.StringEditor;
        HandledBy: Serenity.IntegerEditor;
        Subject: Serenity.StringEditor;
        Note: Serenity.TextAreaEditor;
        ChatLog: Serenity.StringEditor;
        EndTime: Serenity.DateEditor;
        TawkToEvent: Serenity.EnumEditor;
        Department: Serenity.EnumEditor;
        IsActive: Serenity.BooleanEditor;
        InsertUserId: Serenity.IntegerEditor;
        InsertDate: Serenity.DateEditor;
        UpdateUserId: Serenity.IntegerEditor;
        UpdateDate: Serenity.DateEditor;
    }

    export class TawkToChatForm extends Serenity.PrefixedContext {
        static formKey = 'Masters.TawkToChat';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!TawkToChatForm.init)  {
                TawkToChatForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.TextAreaEditor;
                var w4 = s.EnumEditor;
                var w5 = s.BooleanEditor;

                Q.initFormType(TawkToChatForm, [
                    'ChatId', w0,
                    'StartTime', w1,
                    'Name', w0,
                    'Email', w0,
                    'Mobile', w0,
                    'SerialKey', w0,
                    'HandledBy', w2,
                    'Subject', w0,
                    'Note', w3,
                    'ChatLog', w0,
                    'EndTime', w1,
                    'TawkToEvent', w4,
                    'Department', w4,
                    'IsActive', w5,
                    'InsertUserId', w2,
                    'InsertDate', w1,
                    'UpdateUserId', w2,
                    'UpdateDate', w1
                ]);
            }
        }
    }
}
